<rappider-title-toolbar [mainTitle]="mainTitle"
                        [options]="title"></rappider-title-toolbar>

<section class="all-projects">
  <rappider-list-grid [config]="ALL_PROJECTS_CONFIG"
                      [data]="allProjects"
                      [loading]="isLoading"
                      [pageNumber]="pageIndex"
                      [searchActive] ="false"
                      [searchButtonActive]="true"
                      (searchTextChangeOnButtonClick)="searchTextChange($event)"
                      (columnActionClick)="onColumnActionClick($event)"
                      (paginationChange)="paginationChange($event)"
                      (columnItemClick)="onColumnItemClick($event)"></rappider-list-grid>
</section>
<rappider-modal [visible]="modalVisibility"
                [title]="modalTitle"
                [okText]="'Submit'"
                [width]="'60%'"
                [closeIconVisibility]="false"
                [okDisabled]="!isFormValid"
                (cancelClick)="formCancel()"
                (okClick)="formSubmit()">
                <rappider-crud-view-edit-form [config]="ADMIN_PROJECTS_FORM_CONFIG"
                                              [data]="projectData"
                                              [submitted]="isFormSubmit"
                                              (validityChange)="onValidityChange($event)"
                                              (formValueChange)="onFormValueChange($event)"></rappider-crud-view-edit-form>
</rappider-modal>
